import React from 'react';
import { Field } from 'redux-form';
import { TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  email: {
    width: 320
  },
  name: {
    width: 250
  },
  password: {
    width: 250
  }
});

type Props = {
  classes: any
};

const Settings = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Field name="first_name" source="first_name" component={TextInput} label="First name *" className={props.classes.name} /><br />
      </div>
      <div style={{ flex: 2 }}>
        <Field name="last_name" source="last_name" component={TextInput} label="Last name *" className={props.classes.name} /><br />
      </div>
    </div>

    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Field name="password" source="password" component={TextInput} type="password" label="Password" className={props.classes.password} /> &nbsp; &nbsp;
      </div>
      <div style={{ flex: 2 }}>
        <Field name="password_confirmation" source="password_confirmation" component={TextInput} type="password" label="Password confirmation" className={props.classes.password} />
      </div>
    </div>

    <Field name="email" source="email" component={TextInput} type="email" label="Email *" className={props.classes.email} /><br />
  </div>
);

export default withStyles(styles)(Settings);



// WEBPACK FOOTER //
// ./src/views/Components/Profiles/Partials/Settings.tsx